export default [
  {
    path: '/extra-payment-discount',
    name: 'extra-payment-discount',
    component: () => import('@/views/marketing/extra-payment-discount/pages/ExtraPaymentDiscountList.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Extra Payment Discount Config',
      breadcrumb: [
        {
          text: 'Extra Payment Discount Config',
          active: true,
        },
      ],
    },
  },
]
